import { createSelector } from 'reselect';
import { selectors } from '@saucelabs/sl-util-segmentio';
import { utils as cloudTypeUtils } from '@saucelabs/sl-module-cloudtype';

import { TRACKING_AREA, TRACKING_SUB_AREA_DEFAULT } from '../../../trackingV2';

export const eventMetaDataSelector = createSelector(
  [selectors.eventMetaDataSelector, (store, options) => options],
  (eventDefaultData, options) => ({
    ...eventDefaultData,
    product_area: TRACKING_AREA,
    product_sub_area: options?.product_sub_area || TRACKING_SUB_AREA_DEFAULT,
  }),
);

export const createEventMetaDataCloudSelector = (cloudKey) => (
  createSelector([eventMetaDataSelector], (eventMetaData) => {
    const cloudType = cloudTypeUtils.getCloudType(cloudKey);
    return {
      eventMetaData: {
        ...eventMetaData,
        sku_type: cloudType,
      },
    };
  }));
